<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25.1"
        height="47.98"
        viewBox="0 0 25.1 47.98"
    >
        <defs>
            <clipPath id="guaranteed-reviews-company-clip">
                <path
                    fill="none"
                    d="M12.52,28.69a15.68,15.68,0,0,1-7.26-1.78v16.8l7.34-5.63,7.18,5.63V26.91a15.68,15.68,0,0,1-7.26,1.78"
                />
            </clipPath>
        </defs>
        <path
            fill="#fff"
            d="M12.52,28.69a15.68,15.68,0,0,0,7.26-1.78v16.8L12.6,38.08,5.26,43.71V26.91a15.68,15.68,0,0,0,7.26,1.78"
        />
        <g clip-path="url(#guaranteed-reviews-company-clip)">
            <rect
                fill="#0e559e"
                x="2.99"
                y="23.1"
                width="8.13"
                height="24.88"
            />
        </g>
        <g clip-path="url(#guaranteed-reviews-company-clip)">
            <rect
                fill="#e43433"
                x="14.3"
                y="23.1"
                width="8.13"
                height="24.88"
            />
        </g>
        <path
            fill="#175298"
            d="M12.54,0A12.55,12.55,0,1,0,25.1,12.56,12.55,12.55,0,0,0,12.54,0h0"
        />
        <path
            fill="#fff"
            d="M12.54,2.93a9.62,9.62,0,1,0,9.62,9.63,9.62,9.62,0,0,0-9.62-9.63h0"
        />
        <path
            fill="#e43433"
            d="M12.54,5.47a7.08,7.08,0,1,0,7.08,7.08h0a7.09,7.09,0,0,0-7.08-7.08"
        />
        <polygon
            fill="#fff"
            points="14.87 13.39 17.25 11.11 13.99 10.66 12.55 7.7 11.11 10.66 7.85 11.11 10.23 13.39 9.65 16.63 12.55 15.08 15.45 16.63 14.87 13.39"
        />
    </svg>
</template>
